module.exports = __webpack_public_path__ + "img/landingbg_small.b13093c4.jpg";